/*
 * Gedrag van de servicepagina's V2.
 *
 * Vier losse dingen, bewust klein gehouden. Alles werkt zonder dit bestand:
 * de accordeon is details/summary, de navigatie zijn gewone links en het
 * formulier post door als een gewoon formulier. Wat hieronder staat maakt het
 * prettiger, niet mogelijk.
 */

(() => {
  const minderBeweging = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* --------------------------------------------------------------------
     1 · De actieve chip in beeld schuiven
     --------------------------------------------------------------------
     Op een telefoon is de service-index breder dan het scherm. Sta je op
     Verzending, dan staat die chip buiten beeld en lijkt de rij te zeggen dat
     je op Authenticiteit bent. Alleen schuiven als het echt nodig is; op een
     pagina die net geladen is, is onnodige beweging storend.
  */
  const navInBeeld = () => {
    document.querySelectorAll('[data-cs-service-nav]').forEach((rij) => {
      if (rij.scrollWidth <= rij.clientWidth) return;

      const actief = rij.querySelector('.is-active');
      if (!actief) return;

      const a = actief.getBoundingClientRect();
      const r = rij.getBoundingClientRect();
      if (a.left >= r.left && a.right <= r.right) return;

      rij.scrollLeft += a.left - r.left - (r.width - a.width) / 2;
    });
  };

  /* --------------------------------------------------------------------
     2 · Sticky balk op mobiel
     --------------------------------------------------------------------
     Verschijnt zodra de hero voorbij is en verdwijnt weer zodra het doel zelf
     in beeld komt: twee keer dezelfde knop naast elkaar helpt niemand.
  */
  const stickyBalken = () => {
    document.querySelectorAll('[data-cs-sticky]').forEach((balk) => {
      const na = document.querySelector(balk.dataset.csStickyNa || '');
      const tot = balk.dataset.csStickyTot ? document.querySelector(balk.dataset.csStickyTot) : null;
      if (!na) return;

      const bijwerken = () => {
        const voorbij = na.getBoundingClientRect().bottom < 0;
        const doelInBeeld = tot
          ? (() => {
              const r = tot.getBoundingClientRect();
              return r.top < window.innerHeight && r.bottom > 0;
            })()
          : false;

        balk.classList.toggle('is-zichtbaar', voorbij && !doelInBeeld);
      };

      const kijker = new IntersectionObserver(bijwerken, { threshold: [0, 0.01, 1] });
      kijker.observe(na);
      if (tot) kijker.observe(tot);
      window.addEventListener('resize', bijwerken, { passive: true });
      bijwerken();
    });
  };

  /* --------------------------------------------------------------------
     3 · Inhoudsopgave die de scrollpositie volgt
     --------------------------------------------------------------------
     Alleen op Verzending. Die pagina heeft zes paragrafen en is de langste
     van de vier; zonder markering weet je halverwege niet meer waar je bent.
  */
  const inhoudsopgave = () => {
    const toc = document.querySelector('[data-cs-toc]');
    if (!toc) return;

    const links = [...toc.querySelectorAll('a[href^="#"]')];
    const doelen = links
      .map((a) => document.getElementById(a.getAttribute('href').slice(1)))
      .filter(Boolean);
    if (!doelen.length) return;

    const markeer = (id) => {
      links.forEach((a) => {
        const actief = a.getAttribute('href') === '#' + id;
        a.classList.toggle('is-active', actief);
        if (actief) {
          a.setAttribute('aria-current', 'true');
        } else {
          a.removeAttribute('aria-current');
        }
      });
    };

    const kijker = new IntersectionObserver(
      (waarnemingen) => {
        // De bovenste sectie die in beeld staat wint. Zonder die keuze
        // springt de markering heen en weer als er twee tegelijk zichtbaar
        // zijn.
        const zichtbaar = waarnemingen
          .filter((w) => w.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (zichtbaar.length) markeer(zichtbaar[0].target.id);
      },
      { rootMargin: '-96px 0px -55% 0px', threshold: 0 }
    );

    doelen.forEach((d) => kijker.observe(d));
  };

  /* --------------------------------------------------------------------
     4 · Aanvraagformulier: validatie en states
     --------------------------------------------------------------------
     De browser valideert zelf, maar zijn meldingen verdwijnen bij de
     eerstvolgende klik en zijn niet te vinden met een schermlezer. Daarom een
     eigen melding per veld plus een samenvatting bovenaan waar de focus heen
     gaat. Bij blur pas melden, niet tijdens het typen: iemand die halverwege
     een e-mailadres zit heeft geen fout gemaakt, hij is nog bezig.
  */
  const formulier = () => {
    const form = document.querySelector('[data-cs-aanvraag]');
    if (!form) return;

    const samenvatting = form.querySelector('[data-cs-fouten]');
    const lijst = samenvatting ? samenvatting.querySelector('ul') : null;
    const knop = form.querySelector('[data-cs-verzend]');

    const velden = [...form.querySelectorAll('input[required], select[required], textarea[required]')];

    const meldingVan = (veld) => form.querySelector('[data-cs-fout-voor="' + veld.name + '"]');

    const toonFout = (veld) => {
      const melding = meldingVan(veld);
      const tekst = veld.validity.valueMissing
        ? veld.dataset.csLeeg || 'Vul dit veld in.'
        : veld.dataset.csOngeldig || 'Controleer dit veld.';

      veld.setAttribute('aria-invalid', 'true');
      if (melding) melding.textContent = tekst;
      return tekst;
    };

    const wisFout = (veld) => {
      veld.removeAttribute('aria-invalid');
      const melding = meldingVan(veld);
      if (melding) melding.textContent = '';
    };

    velden.forEach((veld) => {
      veld.addEventListener('blur', () => {
        if (veld.value.trim() === '' && !veld.dataset.csAangeraakt) return;
        veld.dataset.csAangeraakt = '1';
        if (veld.checkValidity()) {
          wisFout(veld);
        } else {
          toonFout(veld);
        }
      });

      veld.addEventListener('input', () => {
        if (veld.getAttribute('aria-invalid') && veld.checkValidity()) wisFout(veld);
      });
    });

    // Tekenteller onder de toelichting.
    form.querySelectorAll('[data-cs-teller-voor]').forEach((teller) => {
      const veld = form.querySelector('#' + teller.dataset.csTellerVoor);
      if (!veld) return;
      const max = veld.getAttribute('maxlength') || 500;
      const bij = () => {
        teller.textContent = veld.value.length + ' / ' + max;
      };
      veld.addEventListener('input', bij);
      bij();
    });

    form.addEventListener('submit', (e) => {
      const fout = velden.filter((v) => !v.checkValidity());

      if (fout.length) {
        e.preventDefault();

        if (lijst) {
          lijst.textContent = '';
          fout.forEach((veld) => {
            const tekst = toonFout(veld);
            const label = form.querySelector('label[for="' + veld.id + '"]');
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = '#' + veld.id;
            a.textContent = (label ? label.textContent.trim() : veld.name) + ' — ' + tekst;
            a.addEventListener('click', (ev) => {
              ev.preventDefault();
              veld.focus();
            });
            li.appendChild(a);
            lijst.appendChild(li);
          });
        }

        if (samenvatting) {
          samenvatting.hidden = false;
          samenvatting.focus();
          if (!minderBeweging.matches) {
            samenvatting.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
        return;
      }

      if (samenvatting) samenvatting.hidden = true;

      // Laadstatus. Het formulier post gewoon door naar Shopify, dus dit is
      // alleen om te laten zien dat er iets gebeurt en om dubbel verzenden te
      // voorkomen.
      if (knop) {
        knop.dataset.csLabel = knop.textContent;
        knop.textContent = knop.dataset.csBezig || 'Versturen...';
        knop.disabled = true;
      }
    });
  };

  /* --------------------------------------------------------------------
     Een link naar een anker in dezelfde pagina zacht laten scrollen.
     -------------------------------------------------------------------- */
  const zachtScrollen = () => {
    document.querySelectorAll('[data-cs-scroll-to]').forEach((knop) => {
      knop.addEventListener('click', (e) => {
        const doel = document.querySelector(knop.dataset.csScrollTo);
        if (!doel) return;
        e.preventDefault();
        doel.scrollIntoView({
          behavior: minderBeweging.matches ? 'auto' : 'smooth',
          block: 'start',
        });
      });
    });
  };

  const start = () => {
    navInBeeld();
    stickyBalken();
    inhoudsopgave();
    formulier();
    zachtScrollen();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
